import { t } from "@/i18n-js/instance";

import { FeatureRow } from "../FeatureRow";
import { annualOnlyKey } from "./constants";
import { SectionWrapper } from "./SectionWrapper";

export const Support = () => (
  <SectionWrapper sectionName={t("pricing_plans.section.support")}>
    <FeatureRow
      title={t("pricing_plans.feature.support_tier")}
      basic={t("pricing_plans.feature.standard")}
      professional={t("pricing_plans.feature.standard")}
      business={t("pricing_plans.feature.standard")}
      enterprise={t("pricing_plans.feature.priority")}
      plus={t("pricing_plans.feature.premium")}
      hideCheckIcon
    />
    <FeatureRow
      title={t("pricing_plans.feature.circle_community")}
      basic
      professional
      enterprise
      business
      plus
    />
    <FeatureRow
      title={t("pricing_plans.feature.beta_features")}
      basic={false}
      professional={false}
      business={false}
      enterprise={t(annualOnlyKey)}
      plus
    />
  </SectionWrapper>
);
